import React from "react";

// COMPONENTS
import ContentBox from "@components/ContentBox/ContentBox";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import NumberField from "../../../components/NumberField/NumberField";
import Select from "@components/Select/Select";
import StackLayout from "@components/layouts/StackLayout/StackLayout";

// HELPERS
import {createClassName} from "@helpers/utils";
import i18n from "@helpers/i18n";

// OTHER
import fulfillment from "./FamilyAndAssets.fulfillment";
import OptionsList from "../../../components/OptionsList/OptionsList";
import Validator from "../../../../../classes/Validator";
import TextView from "../../../../../components/TextView/TextView.jsx";


export default class FamilyAndAssets extends React.PureComponent
{
	state = _getInitialState.call(this);
	fields = _getFields.call(this);

	savingOptions = [
		{
			value: "Inget sparande",
			label: "Inget sparande"
		},
		{
			value: "0 - 999 kr",
			label: "0 - 999 kr"
		},
		{
			value: "1 000 - 4 999 kr",
			label: "1 000 - 4 999 kr"
		},
		{
			value: "5 000 - 9 999 kr",
			label: "5 000 - 9 999 kr"
		},
		{
			value: "Mer än 10 000kr",
			label: "Mer än 10 000kr"
		}
	];

	exitOptions = [
		{
			value: "Inom 1 år",
			label: "Inom 1 år"
		},
		{
			value: "Inom 2 år",
			label: "Inom 2 år"
		},
		{
			value: "Inom 3 år",
			label: "Inom 3 år"
		},
		{
			value: "Inom 4 år",
			label: "Inom 4 år"
		},
		{
			value: "Inom 5 år",
			label: "Inom 5 år"
		},
		{
			value: "Inom 6 år",
			label: "Inom 6 år"
		},
		{
			value: "Inom 7 år",
			label: "Inom 7 år"
		},
		{
			value: "Inom 8 år",
			label: "Inom 8 år"
		},
		{
			value: "Inom 9 år",
			label: "Inom 9 år"
		},
		{
			value: "Inom 10 år eller längre",
			label: "Inom 10 år eller längre"
		}
	];

	isFulfilled(state)
	{
		return fulfillment(state, this.state);
	}

	setCustomerState(customerState, callbackFn)
	{
		customerState = {...this.state.customerState, ...customerState};
		this.setState({
			customerState,
			isFulfilled: this.isFulfilled({customerState})
		}, () =>
		{
			this.props.setAppState({viewFulfilled: this.state.isFulfilled});
			if (callbackFn)
			{
				callbackFn();
			}
		});
	}

	setTableData(fields)
	{
		this.setState(prevState => ({
			customerState: {
				...prevState.customerState,
				tableData: {...prevState.customerState.tableData, ...fields}
			}
		}));
	}

	componentDidMount()
	{
		const {setAppState} = this.props;

		// Set navigation events
		setAppState({
			viewFulfilled: this.isFulfilled(),
			showValidationWarning: false,
			navigationButtons: {
				sharing: {},
				back: {},
				next: {
					onClick: () =>
					{
						if (this.state.isFulfilled === true)
						{
							return;
						}

						this.setState({hasFormValidationErrors: true});
						return setAppState({
							showValidationWarning: true
						});
					}
				}
			}
		});
	}

	render()
	{
		const {props, state} = this;
		const {customer} = props;
		const {customerState, readOnly} = state;
		const classes = createClassName("Cob-view Cob-view4", {});
		const hasFormValidationErrors = !this.state.isFulfilled && this.state.hasFormValidationErrors;

		let companyTotalAssets = 0;
		if (customer.isCompany)
		{
			companyTotalAssets += customerState.customer_comp_assets_cash !== "" ? parseInt(customerState.customer_comp_assets_cash.replace(" SEK", "").split(' ').join(''), 10) : 0;
			companyTotalAssets += customerState.customer_comp_assets_fininstr !== "" ? parseInt(customerState.customer_comp_assets_fininstr.replace(" SEK", "").split(' ').join(''), 10) : 0;
			companyTotalAssets += customerState.customer_comp_assets_other !== "" ? parseInt(customerState.customer_comp_assets_other.replace(" SEK", "").split(' ').join(''), 10) : 0;
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.fields}/>

				{customer.isCompany && (
					<React.Fragment>
						<input type="hidden" name="customer_savingsprofile_realestate" value="-"/>
						<input type="hidden" name="customer_savingsprofile_debt" value="-"/>
					</React.Fragment>
				)}

				<ContentBox>
					<h2>Övriga uppgifter</h2>

					{customer.isMinor && (
						<div style={{margin: "0 0 30px 0", padding: "10px", background: "#FFFFCC"}}>
							Då kunden är minderårig ska frågorna i rådgivningen besvaras av vårdnadshavare.
						</div>
					)}

					<div className="Cob-view4-fields">
						{!customer.isCompany && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									Familjeinformation
								</p>

								<StackLayout className="Cob-fields-collection per-row-3" rowWrap fullWidth>
									<div>
										<Select
											name="customer_maritalstatus"
											label="Civilstånd"
											selectedIndex={customerState.maritalStatusIndex}
											options={[
												{label: "Ensamstående", value: "Ensamstående"},
												{label: "Sambo", value: "Sambo"},
												{label: "Gift/Reg. partner", value: "Gift/Reg. partner"},
												{label: "Änka/Änkling", value: "Änka/Änkling"},
												{label: "Skild", value: "Skild"}
											]}
											onChange={(option, maritalStatusIndex) => this.setCustomerState({
												maritalStatus: option.value,
												maritalStatusIndex
											})}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>

										{(customerState.maritalStatus === 'Sambo' ||
											customerState.maritalStatus === 'Gift/Reg. partner') && (
											<input type="hidden" name="radio_customer_partner" value="yes"/>
										)}

										{(customerState.maritalStatus === 'Ensamstående' ||
											customerState.maritalStatus === 'Skild' ||
											customerState.maritalStatus === 'Änka/Änkling') && (
											<input type="hidden" name="radio_customer_partner" value="no"/>
										)}
									</div>

									<div className="item">
										<Select
											label={i18n("cob", "total_service_obligation")}
											selectedIndex={customerState.customer_child_no_index}
											name="customer_child_no"
											options={[
												{label: "0", value: "0"},
												{label: "1", value: "1"},
												{label: "2", value: "2"},
												{label: "3", value: "3"},
												{label: "4+", value: "4+"}
											]}
											onChange={(option, customer_child_no_index) => this.setCustomerState({
												customer_child_no: option.value,
												customer_child_no_index
											})}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
								</StackLayout>

								<p className={"field-label with-previous"}>
									Kundens månadsinkomst och sparande
								</p>

								<StackLayout className="Cob-fields-collection per-row-3" rowWrap fullWidth>
									<div>
										<NumberField
											name="customer_salary"
											label="Bruttoinkomst"
											unit=" SEK"
											value={customerState.salary || ""}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({salary: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
									<div className="item">
										<Select
											name="customer_monthly_savings"
											label={"Ange månadssparande"}
											selectedIndex={this.savingOptions.map(c => c.value).indexOf(customerState.customer_monthly_savings)}
											options={this.savingOptions}
											onChange={(option) => { this.setCustomerState({customer_monthly_savings: option.value}); }}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
								</StackLayout>
							</React.Fragment>
						)}

						<OptionsList
							style={{marginBottom: "0"}}
							type="radio"
							description={"Planerar kunden att sälja sitt bolag?"}
							name="radio_customer_plans_exit"
							value={customerState.radio_customer_plans_exit}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_plans_exit === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_plans_exit === "yes"
								}
							]}
							onChange={(checked, radio_customer_plans_exit) => this.setCustomerState({radio_customer_plans_exit})}
							validation={(value) => ((value && value.length > 0) || false)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>

						{customerState.radio_customer_plans_exit === "yes" && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									När planerar kunden eventuell försäljning?
								</p>
								<Select
									name="customer_plans_exit_when"
									label={"Välj"}
									selectedIndex={this.exitOptions.map(c => c.value).indexOf(customerState.customer_plans_exit_when)}
									options={this.exitOptions}
									onChange={(option) => { this.setCustomerState({customer_plans_exit_when: option.value}); }}
									highlightErrors={hasFormValidationErrors}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}

						{customer.isCompany && (
							<React.Fragment>

								<div className="h-line spacing"/>

								<h3>Historiskt resultat</h3>
								<p style={{marginTop: "0", fontSize: "13px"}}>Ange värden före skatt.</p>
								<StackLayout className="Cob-fields-collection per-row-3" rowWrap fullWidth>
									<div>
										<NumberField
											name="customer_comp_histresult1"
											label="1 år sedan (senaste årsbokslut)"
											unit=" SEK"
											value={customerState.customer_comp_histresult1 || ""}
											allowNegative={true}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_histresult1: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
									<div>
										<NumberField
											name="customer_comp_histresult2"
											label="2 år sedan"
											unit=" SEK"
											value={customerState.customer_comp_histresult2 || ""}
											allowNegative={true}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_histresult2: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
									<div>
										<NumberField
											name="customer_comp_histresult3"
											label="3 år sedan"
											unit=" SEK"
											value={customerState.customer_comp_histresult3 || ""}
											allowNegative={true}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_histresult3: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
								</StackLayout>

								<h3>Uppskattat resultat kommande period</h3>
								<p style={{marginTop: "0", fontSize: "13px"}}>Ange värden före skatt.</p>
								<StackLayout className="Cob-fields-collection per-row-3" rowWrap fullWidth>
									<div>
										<NumberField
											name="customer_comp_budresult12m"
											label="12 månader (kommande årsbokslut)"
											unit=" SEK"
											value={customerState.customer_comp_budresult12m || ""}
											allowNegative={true}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_budresult12m: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
									<div>
										<NumberField
											name="customer_comp_budresult24m"
											label="24 månader"
											unit=" SEK"
											value={customerState.customer_comp_budresult24m || ""}
											allowNegative={true}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_budresult24m: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
								</StackLayout>

								<h3>Tillgångar</h3>
								<StackLayout className="Cob-fields-collection per-row-3" rowWrap fullWidth>
									<div>
										<NumberField
											name="customer_comp_assets_cash"
											label="Bankkonto"
											unit=" SEK"
											value={customerState.customer_comp_assets_cash || ""}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_assets_cash: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
									<div>
										<NumberField
											name="customer_comp_assets_fininstr"
											label="Finansiella instrument"
											unit=" SEK"
											value={customerState.customer_comp_assets_fininstr || ""}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_assets_fininstr: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
									<div>
										<NumberField
											name="customer_comp_assets_other"
											label="Övrigt (t.ex. moms eller skattelättn.)"
											unit=" SEK"
											value={customerState.customer_comp_assets_other || ""}
											showSeparators={true}
											onChange={({target}) =>
											{
												this.setCustomerState({customer_comp_assets_other: target.value.split(' ').join('')});
											}}
											highlightErrors={hasFormValidationErrors}
											readOnly={readOnly}
										/>
									</div>
								</StackLayout>

								<div className="Cob-TableSummary" style={{marginTop: "-10px"}}>
									<div className="Cob-TableSummary-container">
										<div className="Cob-TableSummaryField">
											<div className="Cob-TableSummaryField-label">
												Summa placeringsbara tillgångar
											</div>
											<div className="Cob-TableSummaryField-value">{companyTotalAssets} SEK</div>
										</div>
									</div>
								</div>
								<input type="hidden" name="customer_comp_assets_sum"
								       value={companyTotalAssets + " SEK"}/>
								<input type="hidden" name="checkbox_customer_id_poa" value="yes"/>
								<input type="hidden" name="checkbox_customer_Certificate_of_registration" value="yes"/>
								<input type="hidden" name="checkbox_company_benowners_jurpers" value="Nej"/>
							</React.Fragment>
						)}

						<div className="h-line spacing" style={{marginTop: "40px"}}/>

						<h3 style={{marginBottom: "20px"}}>
							Övrig information om kundens ekonomiska situation
						</h3>
						<TextView
							name="advice_notes_other"
							label={`Ange vid behov (${1000 - customerState.advice_notes_other.length} tecken kvar)`}
							value={customerState.advice_notes_other}
							maxLength={1000}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({advice_notes_other: target.value})}
							fullWidth
							minHeight={250}
						/>
					</div>
				</ContentBox>
			</div>
		);
	}

	_textValidation = (value) => (value.length > 0);

	_optionsValidation = (value) => ((value && value.length > 0) || false);

	/**
	 * SSN numbers need to be 12 digits and start with 19 or 20
	 */
	_ssnValidation = (value) => (!isNaN(value) && value.length === 12 &&
		(value.substring(0, 2) === "19" || value.substring(0, 2) === "20") && Validator.validateSsn(value)
	);
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
	const {customer, viewNo, hasFormValidationErrors, readOnly} = this.props;
	const seenViews = JSON.parse(localStorage.getItem(`SEEN_VIEWS_${btoa(customer.caseId)}`)) || [];
	const hasBeenSeen = (seenViews.includes(viewNo));
	// if it hasn't been seen add the view to local storage for the specific case
	if (customer.caseId && !hasBeenSeen)
	{
		localStorage.setItem(`SEEN_VIEWS_${btoa(customer.caseId)}`, JSON.stringify([...seenViews, viewNo]));
	}

	let newState = getViewInitialStateForCustomer(customer);
	newState.isFulfilled = this.isFulfilled(newState);
	newState.hasFormValidationErrors = hasBeenSeen || hasFormValidationErrors;
	newState.readOnly = readOnly;
	return newState;
}

export function getViewInitialStateForCustomer(customer)
{
	const newState = {
		customerState: {
			isCompany: customer.isCompany,

			customer_comp_histresult1: customer.getData("customer_comp_histresult1"),
			customer_comp_histresult2: customer.getData("customer_comp_histresult2"),
			customer_comp_histresult3: customer.getData("customer_comp_histresult3"),

			customer_comp_budresult12m: customer.getData("customer_comp_budresult12m"),
			customer_comp_budresult24m: customer.getData("customer_comp_budresult24m"),

			customer_comp_assets_cash: customer.getData("customer_comp_assets_cash"),
			customer_comp_assets_fininstr: customer.getData("customer_comp_assets_fininstr"),
			customer_comp_assets_other: customer.getData("customer_comp_assets_other"),

			maritalStatus: customer.getData("customer_maritalstatus"),
			customer_partner: customer.getData("customer_partner"),
			customer_monthly_savings: customer.getData("customer_monthly_savings"),
			radio_customer_plans_exit: customer.getData("radio_customer_plans_exit"),
			customer_plans_exit_when: customer.getData("customer_plans_exit_when"),

			monthlyPayment: customer.getData("customer_monthly_payment"),
			savingsProfileRealEstate: customer.isCompany ? "-" : customer.getData("customer_savingsprofile_realestate"),
			savingsProfileDebt: customer.isCompany ? "-" : customer.getData("customer_savingsprofile_debt"),
			tableData: customer.view4TableData,
			salary: customer.getData("customer_salary"),
			advice_notes_other: customer.getData("advice_notes_other"),

			// Select indexes
			maritalStatusIndex: (
				customer.getData("customer_maritalstatus") === "Ensamstående" ? 0 :
					customer.getData("customer_maritalstatus") === "Sambo" ? 1 :
						customer.getData("customer_maritalstatus") === "Gift/Reg. partner" ? 2 :
							customer.getData("customer_maritalstatus") === "Änka/Änkling" ? 3 :
								customer.getData("customer_maritalstatus") === "Skild" ? 4 :
									-1
			),

			customer_child_no: customer.getData("customer_child_no"),
			customer_child_no_index: (
				customer.getData("customer_child_no") === "0" ? 0 :
					customer.getData("customer_child_no") === "1" ? 1 :
						customer.getData("customer_child_no") === "2" ? 2 :
							customer.getData("customer_child_no") === "3" ? 3 :
								customer.getData("customer_child_no") === "4+" ? 4 :
									-1
			)
		}
	};

	newState.isFulfilled = false;
	return newState;
}

function _getFields()
{
	return [
		"radio_customer_plans_exit",
		"customer_plans_exit_when",
		"customer_maritalstatus",
		"customer_comp_assets_sum",
		"customer_salary",
		"customer_monthly_savings",
		"advice_notes_other"
	];
}